import React from 'react'
import img1 from '../../img/img1.JPG'
import '../Projects.css';


function Project1() {

    return (
        <>
            <div className='container-projects'>
                <img src={img1} />
                <div className='project-description'>
                    <h2 className='titulo-projects'>Renovation </h2>
                    The renovation of the facades of the "Vista Hermosa" residential complex was a key initiative to revitalize the appearance and functionality of the buildings. The primary goal of this project was to modernize the complex's image, improve the durability of the structures, and enhance the visual appeal of the residential environment.<br></br><br></br>

                    <h1>Renovation Details:</h1>
                    <h1>Initial Evaluation and Planning:</h1><br></br>
                    Technical Inspection: A thorough assessment of the current conditions of the facades was conducted, identifying areas with structural damage, coating wear, and moisture problems.<br></br><br></br>
                    Architectural Design: Architects designed new facades that combined modern elements with the original aesthetics of the residential complex. Several proposals were presented to the residents to ensure their satisfaction and approval.
                    
                </div>

            </div>
        </>
    )



}

export default Project1